import { useEffect, useState, useCallback } from "react";
import { RequestServer } from "../../../../utils/services";
import { APIRoutes } from "../../../../constants";
import { agendaObj } from "./types";

type Props = {
  projectId: number | null;
};

const usePanelAgendaData = ({ projectId }: Props) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [agendaArray, setAgendaArray] = useState<agendaObj[]>([]);
  const [filteredAgendaArray, setFilteredAgendaArray] = useState<any[]>([]);

  const fetchAgendaData = useCallback(async () => {
    if (!projectId) return;

    try {
      setLoading(true);
      const { data: peAgendaList } = await RequestServer(
        `${APIRoutes.PE_AGENDA}?fk_project=${projectId}&embed=YES`,
        "GET"
      );
      
      const uniqueIds = new Set<number>();
      peAgendaList.forEach((item: any) => {
        uniqueIds.add(item.fk_agenda);
      });

      const uniqueAgendaIds = Array.from(uniqueIds);
      const agendaList = await RequestServer(
        `/projects/agenda?action=GetAgenda&fk_project=${projectId}&in___id=${uniqueAgendaIds.join(
          ","
        )}&embed=YES`,
        "GET"
      );

      const uniqueAgendas = new Map<number, agendaObj>();
      agendaList.data.forEach((item: any) => {
        if (!uniqueAgendas.has(item.id)) {
          uniqueAgendas.set(item.id, {
            ...item,
          });
        }
      });

      const expertMap: Record<number, any> = {};
      peAgendaList.forEach((item: any) => {
        const projectExpertId = item.fk_pe;
        if (!expertMap[projectExpertId]) {
          expertMap[projectExpertId] = {
            id: projectExpertId,
            expert_name: item.fk_expert_value.name,
            expert_id: item.fk_expert,
            agenda_responses: [],
            status: [],
            fk_agenda: [],
            expert_invitation: item.fk_pe_value.expert_invitation,
            meta: item.fk_pe_value.meta,
            agenda_shared_on: item.agenda_shared_on,
            is_shared_with_client: []
          };
        }
        expertMap[projectExpertId].agenda_responses.push(item.agenda_responses || []);
        expertMap[projectExpertId].status.push(item.status || "");
        expertMap[projectExpertId].is_shared_with_client.push(item.is_shared_with_client || "");
        expertMap[projectExpertId].fk_agenda.push(item.fk_agenda);
      });

      setFilteredAgendaArray(Object.values(expertMap));
      setAgendaArray(Array.from(uniqueAgendas.values()));
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchAgendaData();
  }, [fetchAgendaData]);

  return {
    agendaArray,
    filteredAgendaArray,
    loading,
    refetch: fetchAgendaData,
  };
};

export default usePanelAgendaData;